<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card elevation="12" class="justify-center">
      <v-card-title class="justify-center">
        <span v-if="invoice===null" class="headline">{{ $t('CreateInvoiceModal.NEW INVOICE') }}</span>
        <span v-if="invoice!==null" class="headline">{{ $t('CreateInvoiceModal.MODIFY INVOICE') }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <Formulary ref="form" :invoice="invoice" @close="onClose()" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Formulary from "./Formulary";
export default {
    name: 'CreateInvoiceModal',
    components: {Formulary},
    data: () => ({
        dialog: false,
        invoice: null,
    }),
    created () {

    },
    methods: {
        onClose () {
            this.$data.dialog = false;
            this.invoice = null;
            this.$emit('refresh');
        },
        show (invoice) {
            this.$data.dialog = true;

            if (invoice !== null) {
                this.invoice = invoice;
            }
            if (this.$refs.form !== undefined) this.$refs.form.new(this.invoice);
        },
        hide () {
            this.$data.dialog = false;
        },
        reset () {
            if (this.$refs.form !== undefined)
                this.$refs.form.new();
        }
    }
};
</script>
